import { RouteRecordRaw } from 'vue-router'

/**
 * EasyApis 模块的子路由配置
 * 所有路由都会自动加上 /easyapis 前缀
 */
const easyApisRoutes: Array<RouteRecordRaw> = [
  {
    // EasyApis 模块首页
    path: '',
    name: 'EasyApisHome',
    component: () => import('../views/EasyApisHome.vue'),
    meta: {
      title: 'EasyApis',
      icon: 'checkmark-circle-outline'
    }
  },
  {
    // 记账模块
    path: 'jizhang',
    name: 'JiZhang',
    redirect: '/easyapis/jizhang',
    meta: {
      title: '记账',
      parent: 'EasyApis'
    },
    children: [
      {
        // 解锁页（输入访问密码）。本身不能加 requiresAuth，否则死循环。
        path: 'unlock',
        name: 'JiZhangUnlock',
        component: () => import('../views/JiZhang/JiZhangUnlock.vue'),
        meta: {
          title: '记账 - 解锁',
          parent: '记账'
        }
      },
      {
        // 记账首页（显示榆林/神木卡片）
        path: '',
        name: 'JiZhangHome',
        component: () => import('../views/JiZhang/JiZhangHome.vue'),
        meta: {
          title: '记账',
          parent: 'EasyApis',
          requiresJiZhangAuth: true
        }
      },
      {
        // 榆林记账
        path: 'yulin',
        name: 'YuLin',
        component: () => import('../views/JiZhang/YuLin/YuLinPage.vue'),
        meta: {
          title: '榆林记账',
          parent: '记账',
          requiresJiZhangAuth: true
        }
      },
      {
        // 神木记账
        path: 'shenmu',
        name: 'ShenMu',
        component: () => import('../views/JiZhang/ShenMu/ShenMuPage.vue'),
        meta: {
          title: '神木记账',
          parent: '记账',
          requiresJiZhangAuth: true
        }
      }
    ]
  },
  // 未来可以在这里添加更多子路由
  // {
  //   path: 'other-feature',
  //   name: 'OtherFeature',
  //   component: () => import('../views/OtherFeature.vue'),
  //   meta: {
  //     title: '其他功能',
  //     parent: 'EasyApis'
  //   }
  // }
]

export default easyApisRoutes

